<template>
  <div class="menu-desk bg-dark">
    <div class="logo">
      <img
        class="img-fluid"
        src="https://cdn.easydelivery.com.br/logo-e.png"
        alt="Logo Easy Delivery"
      />
    </div>

    <div class="tooltip-container">
      <div
        data-tooltip="Horários"
        class="status-store"
        :class="{
          close: !isOpenMenu && !isPausedMenu,
          pause: isPausedMenu,
          open: !!isOpenMenu && !isPausedMenu,
          loading: (isOpenMenu === null || isPausedMenu) && !timeleft,
        }"
        @click="changeTo('horario')"
      >
        <div class="circle"></div>
        <i class="fas fa-circle"></i>
      </div>
    </div>

    <div class="tooltip-container">
      <div
        class="store-details"
        @click="openDrawer()"
        data-tooltip="Minha loja"
      >
        <i class="fal fa-store" />
      </div>
    </div>

    <ul class="itens-desk">
      <li
        v-for="(link, i) in activeLinks"
        :key="i"
        :data-tooltip="link.tooltip"
      >
        <router-link :to="{ name: link.name }">
          <i :class="link.icon"></i>
          <span
            v-if="typeof link.getCounter == 'function' && link.getCounter() > 0"
            class="notification"
          >
            {{ link.name !== 'pedidos' ? link.getCounter() : '!' }}
          </span>
        </router-link>
      </li>
      <li data-tooltip="Sair">
        <a @click="logout()"><i class="fal fa-power-off"></i></a>
      </li>
    </ul>
    <div
      v-if="hasUpdate || updateLater"
      class="update-later"
      @click="toggleUpdate"
    >
      <span class="pulse"></span>
      <i class="fal fa-arrow-circle-down fs-24" />
    </div>

    <DrawerStoreDetails ref="drawerStoreDetails" />
  </div>
</template>

<script>
/* eslint-disable no-plusplus */
/* eslint-disable prefer-destructuring */
import { mapState } from 'vuex';
import { Role } from 'easyjs/lib/Role/Group';
import SocketIO from 'easyjs/lib/Socket/SocketIO';
import dayjs from 'dayjs';
import Timezone from 'easyjs/lib/Tools/Timezone';
import Store from 'easyjs/lib/Schema/Store';
import { setXUserKey } from '@/plugins/account';
import store from '@/store';
import router from '@/router';
import Utils from '@/utils';
import StoreAPI from '@/api/store';
import DrawerStoreDetails from '@/containers/DrawerStoreDetails';

export default {
  timers: {
    timeLeft: { time: 1000, autostart: true, repeat: true },
  },
  data() {
    return {
      controller: '',
      isOpenController: false,
      isOpenMenu: this.isOpen,
      isPausedMenu: this.isPaused,

      links: [
        /* OCB
        {
          name: "home",
          tooltip: 'Home',
          icon: "fal fa-home",
        },
        OCB */
        {
          name: 'pedidos',
          tooltip: 'Pedidos',
          icon: 'fal fa-receipt',
          getCounter: () => {
            const { hasPendingOrders } = this;
            return hasPendingOrders ? 1 : 0;
          },
        },
        // {
        //   name: 'easy-performance',
        //   tooltip: 'Easy Performance',
        //   icon: 'fal fa-rocket',
        // },
        /* OCB
        {
          name: 'atendimento',
          tooltip: 'Atendimento',
          icon: 'fal fa-phone-alt',
        },
        OCB */
        {
          name: 'cupons',
          tooltip: 'Cupons',
          icon: 'fal fa-tag',
        },
        {
          name: 'relatorios',
          tooltip: 'Relatórios',
          icon: 'fal fa-chart-bar',
        },
        {
          name: 'configuracoes',
          tooltip: 'Configurações',
          icon: 'fal fa-cog',
          getCounter: () => {
            let counter = 0;
            const { storeConfiguration: configurations } = this;

            if (!configurations.catalogChanged) {
              counter++;
            }

            if (
              !configurations.images ||
              !configurations.images.logo ||
              !configurations.images.background_mobile
            ) {
              counter++;
            }

            return counter;
          },
        },
        {
          name: 'integracoes',
          tooltip: 'Integrações',
          icon: 'fal fa-puzzle-piece',
        },
        {
          name: 'minha-conta',
          tooltip: 'Minha conta',
          icon: 'fal fa-address-card',
        },
      ],
      timeleft: 0,
    };
  },
  components: {
    DrawerStoreDetails,
  },
  props: {
    isOpen: null,
    isPaused: false,
  },
  async mounted() {
    if (!this.storeConfiguration.isNotFirstTime) {
      await StoreAPI.storeConfiguration({ isNotFirstTime: true });
      this.$refs.drawerStoreDetails.openDrawer();
    }
  },
  methods: {
    timerController() {
      if (!this.storeConfiguration.working_time) {
        this.$store.dispatch('store/getConfigurations', false);
      }

      const storeObject = Store.fromObject(this.storeConfiguration);
      const now = Timezone.adjustTime(new Date(), 0);
      const open = storeObject.working_time.isOpen(now);
      if (open) {
        this.isOpenMenu = true;
        this.isPausedMenu = false;
      } else {
        this.isOpenMenu = false;
        this.isPausedMenu = false;
      }
    },
    openDrawer() {
      this.$refs.drawerStoreDetails.openDrawer();
    },
    logout() {
      setXUserKey();
      this.$store.dispatch('account/cleanUser');
      this.$store.dispatch('deliveryPlatform/cleanConfigurations');
      SocketIO.close();
      this.$router.push({ name: 'login' });
    },
    toggleUpdate() {
      store.commit('store/setHasUpdate', true);
      store.commit('store/setUpdateLater', false);
    },
    changeTo(routeName) {
      this.statusOptions = !this.statusOptions;

      router.push(routeName);
    },
    pauseStore(unit, interval) {
      this.$emit('pauseStore', { unit, interval });
      this.statusOptions = !this.statusOptions;
    },
    calculeTimePaused() {
      if (this.storeConfiguration.status) {
        const dest = dayjs(this.storeConfiguration.status.paused).add(
          this.storeConfiguration.status.unit,
          this.storeConfiguration.status.interval
        );
        if (dayjs().isAfter(dest)) {
          if (this.isPaused) {
            this.$store.dispatch('store/getConfigurations', false);
          }
          // this.isPaused = true
          // this.$store.dispatch('store/getConfigurations', false)
        }
        this.timeleft = Utils.timeTo(dest);
      }
    },
    timeLeft() {
      this.calculeTimePaused();
    },
    publishStore() {
      this.$store.dispatch('store/changePublishStatus', true);
    },
  },
  created() {
    this.currentRoute = this.$router.currentRoute.name;
    this.timerController();
    setInterval(this.timerController, 30000);
  },
  watch: {
    // Ações na troca de rota
    $route() {
      this.currentRoute = this.$router.currentRoute.name;
    },
    storeConfiguration() {
      this.calculeTimePaused();
      this.timerController();
    },
  },
  computed: {
    ...mapState({
      oUser: (state) => state.account.oUser,
      storeConfiguration: (state) => state.store.configurations,
      storeInfo: (state) => state.store.info,
      hasUpdate: (state) => state.store.hasUpdate,
      updateLater: (state) => state.store.updateLater,
      hasPendingOrders: (state) => state.store.hasPendingOrders,
    }),
    activeLinks() {
      return this.links.filter(
        (l) =>
          l.name != 'usuarios' ||
          (l.name == 'usuarios' &&
            this.oUser &&
            [Role.ADMIN, Role.MASTER].includes(this.oUser.group))
      );
    },
  },
};
</script>

<style scoped>
.menu-desk {
  height: 100vh;
  width: 60px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  display: flex;
  padding-top: 11px;
}

.logo img {
  width: 34px;
}

.notification {
  width: 19px;
  height: 19px;
  background: var(--default);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #fff;
  position: absolute;
  right: -3px;
  top: 0;
}

.update-later {
  position: absolute;
  bottom: 25px;
  cursor: pointer;
  color: var(--default);
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.update-later .pulse {
  background-color: #ff33824f;
  filter: blur(5px);
  display: block;
  position: absolute;
  inset: 0;
  border-radius: 50%;
  animation: pulse 2.5s infinite ease-in-out;
}

@keyframes pulse {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.3);
  }
  100% {
    transform: scale(0);
  }
}

.itens-desk {
  list-style: none;
  padding-top: 25px;
  margin-top: 20px;
  border-top: 1px solid #9999991a;
  font-size: 15px;
  width: 100%;
}

.itens-desk li {
  position: relative;
}

.itens-desk li a {
  width: 36px;
  height: 36px;
  border-radius: 5px;
  margin: auto;
  margin-bottom: 17px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
}

.itens-desk li a {
  color: var(--icon-inactive);
  text-decoration: none;
}

.itens-desk li:hover a {
  color: var(--default);
}

.itens-desk li a.router-link-exact-active.router-link-active {
  background-color: var(--default);
  color: #fff;
}

.itens-desk
  li
  a.router-link-exact-active.router-link-active[href*='configuracoes']
  .notification {
  display: none;
}

.itens-desk li a[href='/'] .notification {
  display: none;
}

.store-details {
  background: #2a2c2f;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 25px;
  height: 25px;
  cursor: pointer;
}

.store-details i {
  font-size: 12px;
  color: var(--icon-inactive);
}

.status-store {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  width: 25px;
  height: 25px;
  cursor: pointer;
}

.status-store > .circle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  filter: blur(2px);
}

.status-store > .circle + i {
  width: 9px;
  height: 9px;
  position: absolute;
}

.status-store.open {
  background-color: #0dc59d1a;
}
.status-store.open > .circle {
  background-color: #0dc59d78;
}
.status-store.open > .circle + i {
  color: var(--success);
}
.status-store.close,
.status-store.pause,
.status-store.loading {
  background-color: transparent;
}
.status-store.close > .circle {
  background-color: #e2556963;
}
.status-store.close > .circle + i {
  color: #e25569;
}
.status-store.pause > .circle {
  background-color: #e2556963;
}
.status-store.pause > .circle + i {
  color: #e25569;
}

.tooltip-container {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100%;
  margin-top: 5px;
  min-height: 36px;
}

[data-tooltip]:after,
[data-tooltip]:before {
  visibility: hidden;
  opacity: 0;
  position: absolute;
  left: auto;
  right: auto;
  box-sizing: border-box;
  transition: all 0.25s ease;
}
[data-tooltip]:after {
  content: attr(data-tooltip);
  background: #414147;
  top: 0;
  padding: 0.5rem 20px;
  color: #fff;
  line-height: 1.5;
  font-size: 12px;
  left: 80px;
  text-align: center;
  border-radius: 5px;
  white-space: nowrap;
}
[data-tooltip]:before {
  content: '';
  top: 10px;
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
  border-right: 8px solid #414147;
  left: auto;
  right: -20px;
  margin: auto;
  width: 20px;
}
[data-tooltip]:hover:after,
[data-tooltip]:hover:before {
  visibility: visible;
  opacity: 1;
}
</style>
